import request from '@/utils/http';
// 查询列表
export const getApDealingsBillList = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/getApDealingsBillList`,
        method: 'post',
        data
    });
};
// 对账单详情调整项
export const getApDealingsAdjustmentList = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/getApDealingsAdjustmentList`,
        method: 'get',
        params: data
    });
};
// 对账单详情款项列表
export const getSupBalanceAccountList = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/getSupBalanceAccountList`,
        method: 'get',
        params: data
    });
};
// 余额明细-导出
export const exportBalanceDetails = (data) => {
    return request({
        url: `/api-srm-web/analysisTenderCalculation/exportAnalysisTenderCalculationExcel`,
        method: 'post',
        data,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 对账单详情保存or确认
export const saveApDealingsBill = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/saveApDealingsBill`,
        method: 'post',
        data
    });
};
// 对账单详情调整项-保存
export const saveApDealingsAdjustments = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/saveApDealingsAdjustments`,
        method: 'post',
        data
    });
};
// 对账单详情调整项-删除
export const deleteApDealingsAdjustments = (data) => {
    return request({
        url: `api-bms-web/efApDealingsBill/deleteApDealingsAdjustments`,
        method: 'post',
        data
    });
};
// 上传 核对费用导出
export const getExportTask = (data) => {
    return request({
        url: `/api-lcp-report/report/task/export`,
        method: 'post',
        data
    });
};
// 附件上传
export const fileUpload = (data) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/fileUpload`,
        method: 'post',
        data
    });
};
// 电子签章
export const electricSign = (data) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/electricSign`,
        method: 'post',
        data
    });
};
// 电子签章撤回
export const recallApElectronic = (data) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/recallApElectronic`,
        method: 'post',
        data
    });
};
// 附件模板下载
export const exportTemplate = (data) => {
    return request({
        url: `/api-bms-web/efApDealingsBill/exportTemplate`,
        method: 'post',
        responseType: 'blob'
    });
};
